/* GEEKFOLK KWS — logika motywu (bez zależności zewnętrznych) */
(function () {
  'use strict';

  var root = document.documentElement;
  var money = function (cents) {
    var fmt = (window.GF && window.GF.moneyFormat) || '{{amount_with_comma_separated}} zł';
    var value = (cents / 100).toFixed(2).replace('.', ',');
    var parts = value.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, parts.join(','));
  };

  /* teksty z window.GF.i18n (wstawiane w layout/theme.liquid) z polskim fallbackiem */
  function t(key, fallback) {
    var d = window.GF && window.GF.i18n;
    return (d && d[key]) || fallback;
  }
  /* prefiks języka, np. '/en/' — dzięki niemu linki i fetch zostają w bieżącym języku */
  function rootUrl() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return r || '/';
  }

  /* ---------------------------------------------------------------- pasek promo */
  function initPromoBar() {
    var bar = document.querySelector('[data-promo-bar]');
    if (!bar) return;
    var key = 'gf-promo-closed-' + (bar.dataset.promoId || '1');
    try {
      if (sessionStorage.getItem(key) === '1') { bar.remove(); return; }
    } catch (e) {}
    var close = bar.querySelector('[data-promo-close]');
    if (close) {
      close.addEventListener('click', function () {
        bar.remove();
        try { sessionStorage.setItem(key, '1'); } catch (e) {}
      });
    }
  }

  /* ---------------------------------------------------------------- menu mobilne */
  function initMobileNav() {
    var nav = document.querySelector('[data-mobile-nav]');
    var overlay = document.querySelector('[data-nav-overlay]');
    if (!nav) return;

    function open() {
      nav.classList.add('is-open');
      if (overlay) overlay.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      nav.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-visible');
      document.body.style.overflow = '';
    }

    document.querySelectorAll('[data-nav-open]').forEach(function (b) {
      b.addEventListener('click', open);
    });
    document.querySelectorAll('[data-nav-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  /* ---------------------------------------------------------------- mega menu overlay */
  function initMegaMenu() {
    var overlay = document.querySelector('[data-nav-overlay]');
    if (!overlay) return;
    document.querySelectorAll('[data-has-mega]').forEach(function (item) {
      item.addEventListener('mouseenter', function () { overlay.classList.add('is-visible'); });
      item.addEventListener('mouseleave', function () { overlay.classList.remove('is-visible'); });
    });
  }

  /* ---------------------------------------------------------------- karuzele */
  function initCarousels() {
    document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('[data-carousel-track]');
      var prev = carousel.querySelector('[data-carousel-prev]');
      var next = carousel.querySelector('[data-carousel-next]');
      if (!track) return;

      function step() {
        var first = track.firstElementChild;
        if (!first) return 300;
        return first.getBoundingClientRect().width + 24;
      }
      function sync() {
        if (!prev || !next) return;
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  /* ---------------------------------------------------------------- galeria produktu */
  function initProductGallery() {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (main) {
          main.src = thumb.dataset.full || thumb.querySelector('img').src;
          main.srcset = '';
          main.alt = thumb.dataset.alt || main.alt;
        }
      });
    });
  }

  /* ---------------------------------------------------------------- zakładki */
  function initTabs() {
    document.querySelectorAll('[data-tabs]').forEach(function (tabs) {
      tabs.querySelectorAll('[data-tab-btn]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.dataset.tabBtn;
          tabs.querySelectorAll('[data-tab-btn]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          tabs.querySelectorAll('[data-tab-panel]').forEach(function (p) {
            p.classList.toggle('is-active', p.dataset.tabPanel === id);
          });
        });
      });
    });
  }

  /* ---------------------------------------------------------------- ilość */
  function initQty() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty]');
      if (!btn) return;
      var wrap = btn.closest('.qty');
      var input = wrap && wrap.querySelector('input');
      if (!input) return;
      var value = parseInt(input.value, 10) || 1;
      value += btn.dataset.qty === 'plus' ? 1 : -1;
      if (value < parseInt(input.min || 1, 10)) value = parseInt(input.min || 1, 10);
      input.value = value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------------------------------------------------------------- ulubione */
  var WISH_KEY = 'gf-wishlist';
  function readWishlist() {
    try { return JSON.parse(localStorage.getItem(WISH_KEY) || '[]'); } catch (e) { return []; }
  }
  function writeWishlist(list) {
    try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function refreshWishlistUI() {
    var list = readWishlist();
    document.querySelectorAll('[data-wish]').forEach(function (btn) {
      btn.classList.toggle('is-active', list.indexOf(btn.dataset.wish) !== -1);
    });
    document.querySelectorAll('[data-wish-count]').forEach(function (el) {
      el.textContent = list.length;
      el.style.display = list.length ? '' : 'none';
    });
  }
  function initWishlist() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wish]');
      if (!btn) return;
      e.preventDefault();
      var handle = btn.dataset.wish;
      var list = readWishlist();
      var i = list.indexOf(handle);
      if (i === -1) list.push(handle); else list.splice(i, 1);
      writeWishlist(list);
      refreshWishlistUI();
    });
    refreshWishlistUI();
    renderWishlistPage();
  }
  function renderWishlistPage() {
    var target = document.querySelector('[data-wishlist-render]');
    if (!target) return;
    var list = readWishlist();
    if (!list.length) {
      target.innerHTML = '<div class="empty-state"><p class="empty-state__title">' + t('wishEmptyTitle', 'Nie masz jeszcze ulubionych produktów') + '</p>' +
        '<p class="empty-state__text">' + t('wishEmptyText', 'Kliknij serduszko przy produkcie, aby zapisać go na później.') + '</p>' +
        '<a class="btn btn--outline" href="' + rootUrl() + 'collections/all">' + t('browseProducts', 'Przeglądaj produkty') + '</a></div>';
      return;
    }
    target.innerHTML = '<p class="text-center">' + t('loading', 'Wczytywanie...') + '</p>';
    Promise.all(list.map(function (handle) {
      return fetch(rootUrl() + 'products/' + handle + '?view=card')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (parts) {
      var html = parts.filter(Boolean).join('');
      target.innerHTML = html
        ? '<div class="product-grid">' + html + '</div>'
        : '<div class="empty-state"><p class="empty-state__text">' + t('wishLoadError', 'Nie udało się wczytać ulubionych produktów.') + '</p></div>';
      refreshWishlistUI();
    });
  }

  /* ---------------------------------------------------------------- koszyk AJAX */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count ? '' : 'none';
    });
  }

  function initQuickAdd() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-quick-add]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      if (btn) btn.classList.add('is-loading');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: form.querySelector('[name="id"]').value, quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          if (btn) {
            btn.classList.remove('is-loading');
            var label = btn.innerHTML;
            btn.innerHTML = t('addedShort', 'Dodano ✓');
            setTimeout(function () { btn.innerHTML = label; }, 1600);
          }
        })
        .catch(function () { if (btn) btn.classList.remove('is-loading'); form.submit(); });
    });
  }

  function initCartPage() {
    var page = document.querySelector('[data-cart-page]');
    if (!page) return;
    page.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cart-qty]');
      if (!input) return;
      changeCart(input.dataset.cartQty, input.value);
    });
    page.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-cart-remove]');
      if (!rm) return;
      e.preventDefault();
      changeCart(rm.dataset.cartRemove, 0);
    });
    function changeCart(key, qty) {
      page.style.opacity = '.5';
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: parseInt(qty, 10) })
      }).then(function () { window.location.reload(); });
    }
  }

  /* ---------------------------------------------------------------- podpowiedzi wyszukiwania */
  function initPredictive() {
    var wrap = document.querySelector('[data-predictive-wrap]');
    if (!wrap) return;
    var input = wrap.querySelector('input[name="q"]');
    var panel = wrap.querySelector('[data-predictive]');
    if (!input || !panel) return;
    var timer = null;

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { panel.classList.remove('is-open'); return; }
      timer = setTimeout(function () {
        fetch(rootUrl() + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources.results.product || []);
            var collections = (data.resources.results.collection || []);
            if (!products.length && !collections.length) { panel.classList.remove('is-open'); return; }
            var html = '';
            collections.slice(0, 3).forEach(function (c) {
              html += '<a class="predictive__item" href="' + c.url + '"><div class="predictive__title">' + t('predictiveCategory', 'Kategoria:') + ' <strong>' + c.title + '</strong></div></a>';
            });
            products.forEach(function (p) {
              var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '" alt="">' : '';
              html += '<a class="predictive__item" href="' + p.url + '">' + img +
                '<div><div class="predictive__title">' + p.title + '</div>' +
                '<div class="predictive__price">' + (p.price ? money(parseInt(p.price, 10)) : '') + '</div></div></a>';
            });
            html += '<a class="predictive__all" href="' + rootUrl() + 'search?q=' + encodeURIComponent(q) + '">' + t('predictiveAll', 'Zobacz wszystkie wyniki →') + '</a>';
            panel.innerHTML = html;
            panel.classList.add('is-open');
          })
          .catch(function () { panel.classList.remove('is-open'); });
      }, 220);
    });

    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) panel.classList.remove('is-open');
    });
  }

  /* ---------------------------------------------------------------- warianty produktu */
  function initVariants() {
    var form = document.querySelector('[data-variant-form]');
    if (!form) return;
    var data = document.querySelector('[data-variant-json]');
    if (!data) return;
    var variants = JSON.parse(data.textContent);
    var idInput = form.querySelector('[name="id"]');

    form.addEventListener('change', function () {
      var selected = Array.prototype.map.call(
        form.querySelectorAll('[data-option-index]:checked'),
        function (i) { return i.value; }
      );
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      });
      if (!match) return;
      idInput.value = match.id;
      var priceEl = document.querySelector('[data-variant-price]');
      if (priceEl) priceEl.textContent = money(match.price);
      var compareEl = document.querySelector('[data-variant-compare]');
      if (compareEl) {
        compareEl.textContent = match.compare_at_price > match.price ? money(match.compare_at_price) : '';
        compareEl.parentElement.style.display = match.compare_at_price > match.price ? '' : 'none';
      }
      var skuEl = document.querySelector('[data-variant-sku]');
      if (skuEl && match.sku) skuEl.textContent = match.sku;
      var btn = form.querySelector('[data-add-button]');
      if (btn) {
        btn.disabled = !match.available;
        btn.querySelector('span').textContent = match.available ? t('addToCart', 'Dodaj do koszyka') : t('unavailable', 'Produkt niedostępny');
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    });
  }

  /* ---------------------------------------------------------------- do góry */
  function initBackToTop() {
    var btn = document.querySelector('[data-back-to-top]');
    if (!btn) return;
    window.addEventListener('scroll', function () {
      btn.classList.toggle('is-visible', window.scrollY > 600);
    }, { passive: true });
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ---------------------------------------------------------------- start */
  function init() {
    initPromoBar();
    initMobileNav();
    initMegaMenu();
    initCarousels();
    initProductGallery();
    initTabs();
    initQty();
    initWishlist();
    initQuickAdd();
    initCartPage();
    initPredictive();
    initVariants();
    initBackToTop();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
